import { useSlashRemover } from 'shared/hooks/useSlashRemover'

const SlashRemover = () => {
  useSlashRemover()
  return null
}

export default SlashRemover
